import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import CombinedPreferencesRow from './CombinedPreferencesRow'
import { DefaultButton } from '../../../../components/Buttons';
import { withStyles } from '@material-ui/core';
import { useLanguage } from '../../../../context/LanguageContext';

import './styles.scss';

const SelectButton = withStyles({
	root: {
		color: '#3F51B5',
		border: 'none',
		fontWeight: 'bold',
		fontSize: '16px',
		backgroundColor: 'transparent',
		'&:hover': {
			backgroundColor: '#C6c6c6'
		},
		'&:disabled': {
			color: '#C6c6c6',
		}
	}
})(DefaultButton);

const DeleteAllButton = withStyles({
	root: {
		color: 'rgba(0,150,136, 1)',
		border: 'none',
		fontSize: '16px',
		backgroundColor: 'transparent',
		'&:hover': {
			backgroundColor: '#C6c6c6'
		},
		'&:disabled': {
			color: '#C6c6c6',
		}
	}
})(DefaultButton);

const CombinedPreferencesWindow = props => {
	const { labels } = useLanguage();
	const COMBINED_PREFERENCES = labels.COMBINED_PREFERENCES || {};
	const [disableAddGroup, setDisableAddGroup] = useState(true)

	useEffect(() => {
		if(props.combinedPreferences.length === 0) props.addGroupeSequence() 
	},[])
	useEffect(() => { 
		if(props.combinedPreferences[props.combinedPreferences?.length - 1]?.preferences?.length >= 1){
			setDisableAddGroup(false)
		} else{
			setDisableAddGroup(true)
		}
	},[props.combinedPreferences])
	
  return (
	<div className='Group-Container'>
		{props.combinedPreferences?.map((group, groupIndex) =>{
			return (
				<div 
					key={`group-${group?.groupSequence || groupIndex}`}
					onClick={() => props.setGroupIndexToModify(groupIndex)} 
					className={`
						${props.groupIndex === groupIndex ? 'Group-Container-Active' : 'Group-Container-Not-Active'}
						${props.disableCancel ? '' : 'Group-Container-Disable'}
					`}
				>
					{group?.preferences?.map((bid, bidIndex) => {
						return(							
							<CombinedPreferencesRow 
								key={`bid-${bid?.bidSequence || `${groupIndex}-${bidIndex}`}`}
								preferenceLabel={bid?.description}
								bidSequence={bid?.bidSequence}
								groupSequence={group?.groupSequence}
								preferencesLength={group?.preferences?.length}
								movePreference={props.movePreference}
								removeBidFromCombinedPreferences={props.removeBidFromCombinedPreferences}
								groupIndex={groupIndex}
								bidIndex={bidIndex}
								editPrefFromCombined={props.editPrefFromCombined}
								preferenceOptionId={bid?.preferenceOptionId}
							/>
						)
					})}
					<div style={{display: 'flex', justifyContent: 'space-between'}}>
            <span className='Group-Label'>{COMBINED_PREFERENCES.GROUP} {group?.groupSequence}</span>
						<DeleteAllButton
							onClick={() => props.removeGroupFromCombinedPreferences(group?.groupSequence)}
							disabled={props.combinedPreferences.length === 1 || !props.disableCancel}
						>
							{COMBINED_PREFERENCES.DELETE_ALL}
						</DeleteAllButton>
          </div>
        </div>
      )
    })}
    <SelectButton
				className='Add-Group-Button'
				onClick={() => props.addGroupeSequence()}
				disabled={disableAddGroup || !props.disableCancel}
			>
				{COMBINED_PREFERENCES.NEW_GROUP}
			</SelectButton>
  </div>
  )
}

CombinedPreferencesWindow.defaultProps = {
	combinedPreferences: [],
	addGroupeSequence: () => {},
	setGroupIndexToModify: () => {},
	moveCombinedPreferencesBid: () => {},
	groupIndex: 0,
	movePreference: () => {},
	removeBidFromCombinedPreferences: () => {},
	removeGroupFromCombinedPreferences: () => {},
	editPrefFromCombinedPreferences: () => {},
	disableCancel: true
}

CombinedPreferencesWindow.propTypes = {
	combinedPreferences: PropTypes.array,
	addGroupeSequence: PropTypes.func,
	setGroupIndexToModify: PropTypes.func,
	moveCombinedPreferencesBid: PropTypes.func,
	groupIndex: PropTypes.number,
	movePreference: PropTypes.func,
	removeBidFromCombinedPreferences: PropTypes.func,
	removeGroupFromCombinedPreferences: PropTypes.func,
	editPrefFromCombined: PropTypes.func,
	disableCancel: PropTypes.bool
}

export default CombinedPreferencesWindow